import { Tab } from "@headlessui/react";
import { Link, useLocation } from "react-router-dom";
import { useModules } from "../../hooks";
import { useSelector } from "react-redux";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const HeaderTabs = () => {
  const hasAccount = useSelector(
    (state) =>
      state.client.clientInfo && state.client.clientInfo.accounts_length > 0
  );

  const location = useLocation();
  const { user } = useSelector((state) => state.user);

  const tabs = [
    { label: "Accounts", path: "/" },
    { label: "Cards", path: "/card" },
    { label: "Crypto", path: "/crypto" },
    { label: "Advance Crypto", path: "/crypto-advance" },
  ];

  const isCryptoEnabled = useModules("Crypto");
  const isCardEnabled = useModules("Card");

  let availableTabs = tabs.filter((tab) => {
    if (user?.is_basic_client) {
      return tab.label === "Accounts";
    }

    if (tab.label === "Crypto" || tab.label === "Advance Crypto") {
      return isCryptoEnabled;
    }

    if (tab.label === "Cards") {
      return isCardEnabled;
    }

    return true;
  });

  if (!hasAccount) {
    availableTabs = availableTabs.filter((tab) => tab.label === "Accounts");
  }

  return (
    <Tab.Group>
      <Tab.List className="flex flex-wrap gap-2">
        {availableTabs.map((tab, index) => (
          <SingleTab
            key={index}
            label={tab.label}
            to={tab.path}
            isSelected={tab.path === location.pathname}
          />
        ))}
      </Tab.List>
    </Tab.Group>
  );
};

const SingleTab = ({ label, to, isSelected }) => (
  <Link to={to}>
    <Tab className={classNames("header-tab-base", isSelected ? "header-tab-selected" : "header-tab-unselected")}>
      {label}
    </Tab>
  </Link>
);

export default HeaderTabs;
